import axios from "../axios/index.js";

const urlGetRoomList = "/api/room/get-list";
const urlGetRoomTypeListWithoutPaginate = "/api/room/type/get-list-room-with-roomType";
const urlCreateRoom = "/api/room/create";
const urlGetRoomDetail = "/api/room/detail/";
const urlUpdateRoom = "/api/room/update/";
const urlGetRoomSlug = "/api/room/check-slug";
const urlDeleteRoom = "/api/room/delete/";

//route room type
const urlGetRoomTypeList = "/api/room/type/list";
const urlGetRoomTypeSlug = "/api/room/type/check-slug";
const urlCreateRoomType = "/api/room/type/create";
const urlGetTypeDetail = "/api/room/type/detail/";
const urlUpdateRoomType = "/api/room/type/update/";
const urlDeleteRoomType = "/api/room/type/delete/";
const urlGetChartData = "/api/room/type/chartData";

export default {
    getList(params) {
        return axios.get(urlGetRoomList, { 
            params: params
        });
    },

    getListRoomWithRoomType() {
        return axios.post(urlGetRoomTypeListWithoutPaginate);
    },
    
    create(params, config) {
        return axios.post(urlCreateRoom, params, config);
    },

    getRoomDetail(id) {
        return axios.get(urlGetRoomDetail + id);
    },
    
    update(params, config) {
        return axios.post(urlUpdateRoom + params.id, params, config);
    },
    
    getSlug(params) {
        return axios.post(urlGetRoomSlug, params);
    },
    
    delete(id) {
        return axios.post(urlDeleteRoom + id, id);
    },

    //api room Type
    //get list room type by id of room data
    getTypeList(params) {
        return axios.get(urlGetRoomTypeList, {
            params:params
        });
    },

    getTypeSlug(params) {
        return axios.post(urlGetRoomTypeSlug, params);
    },

    createRoomType(params, config) {
        return axios.post(urlCreateRoomType, params, config);
    },

    getTypeDetail(id) {
        return axios.get(urlGetTypeDetail + id);
    },

    updateType(id, params, config) {
        return axios.post(urlUpdateRoomType + id, params, config);
    },

    deleteType(id) {
        return axios.post(urlDeleteRoomType + id, id);
    },

    /** 
     * get chart data with start date to end date
     */
    getChartData(chartDate) {
        return axios.post(urlGetChartData, chartDate);
    }
};
